import "../../assets/css/Expenses/ExpensesList.css";

export const expenseColumns = ({
  selectedIds,
  handleSelect,
  handleSelectAll,
  onRowClick,
  totalRows,
}) => [

  {
    id: "select",

    label: (
      <input
        type="checkbox"
        checked={
          totalRows > 0 &&
          selectedIds.length === totalRows
        }
        onChange={handleSelectAll}
      />
    ),

    render: (expense) => (
      <input
        type="checkbox"
        checked={selectedIds.includes(expense.id)}
        onChange={() => handleSelect(expense.id)}
        onClick={(e) => e.stopPropagation()}
      />
    ),
  },


  {
    id: "expense_type",

    label: "Expense Type",

    render: (expense) => (
      <span
        className={`expense-badge ${
          expense.expense_type
            ?.toLowerCase()
            .replace(/\s+/g, "-") || ""
        }`}
      >
        {expense.expense_type || "-"}
      </span>
    ),

    exportValue: (expense) =>
      expense.expense_type || "",
  },


  {
    id: "related_to",

    label: "Related To",

    render: (expense) => {

      if (expense.lead)
        return "Lead";

      if (expense.deal)
        return "Deal";

      return "-";
    },


    exportValue: (expense) => {

      if (expense.lead)
        return "Lead";

      if (expense.deal)
        return "Deal";

      return "";
    },
  },


  {
    id: "organization",

    label: "Organization",

    render: (expense) => (
      <div className="expense-org-cell">

        <div className="expense-org-name">
          {expense.organization?.name || "—"}
        </div>


        <div className="expense-org-remark">
          {expense.remarks || "No remarks"}
        </div>

      </div>
    ),


    exportValue: (expense) =>
      expense.organization?.name || "",

    searchValue: (expense) =>
      `${expense.organization?.name || ""} ${expense.remarks || ""}`.trim(),
  },


  {
    id: "amount",

    label: "Amount",

    render: (expense) =>
      expense.amount
        ? `₹${Number(expense.amount).toLocaleString()}`
        : "₹0",


    exportValue: (expense) =>
      expense.amount || 0,
  },


  {
    id: "expense_date",

    label: "Date",

    render: (expense) =>
      expense.expense_date
        ? new Date(
            expense.expense_date
          ).toLocaleDateString()
        : "-",
  },


  {
    id: "created_by",

    label: "Created By",

    render: (expense) =>
      expense.created_by?.name || "-",


    exportValue: (expense) =>
      expense.created_by?.name || "",
  },




];